import {
  checkDiscountAppliedInvalidWhenPaymentMethodChangeBeforeTxnCreated,
  checkDiscountAppliedValidWhenPaymentMethodChangeAfterTxnCreated,
  getDiscountDefault,
} from 'components/Discount/func';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import {
  DESKTOP_MIN_WIDTH,
  FX_EMAIL,
  FX_PHONE,
  HOME_URL,
  METHOD_DEPOSIT,
  METHOD_EPAYMENT,
  METHOD_PAYID,
  METHOD_PAYTO,
} from 'constants';
import {
  FX_ADD_TRANSACTION_PAYMENT_METHOD_INSTRUCTION,
  FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME,
  RESET_FX_ADD_TRANSACTION_PAYMENT_METHOD,
} from 'constants/fx';
import { QuestionIcon } from 'constants/icon';
import withAddPaytoAccountsAgreement from 'features/to/HOCs/payment/withAddPaytoAccountsAgreement';
import PaytoBodyContent from 'features/to/components/payment/payto/PaytoBodyContent';
import usePayment from 'features/to/hooks/payment/usePayment';
import usePayto from 'features/to/hooks/payment/usePayto';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { format } from 'helpers';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import useScrollIntoView from 'hooks/useScrollIntoView';
import useTheme from 'hooks/useTheme';
import { isArray, isEmpty } from 'lodash';
import { useRef } from 'react';
import styled from 'styled-components';
import { textBreakLineWordMixin } from 'styles';
import { stringUtils } from 'utils';

const initialFormField = RESET_FX_ADD_TRANSACTION_PAYMENT_METHOD;

const PaymentMethodItem = withAddPaytoAccountsAgreement(
  ({
    method,
    information,
    setInformation,
    validation,
    setValidation,
    informationChangeBackup,
    setInformationChangeBackup,
    setOpenDiscountImportantPopup,
    setOpenFxPaymentMethodOnChangePopup,
    paymentMethodCache,
    payLimit,
    isDisabled,
    isSelectRequired,
    onSelect: onSelectPaytoAccountAgreement,
  }) => {
    const { t, locate } = useLang();
    const { showPortalModalName } = usePortalModal();
    const { isHHMTTheme, theme } = useTheme();

    const {
      paymentMethod: paymentMethodStore,
      setPaymentMethod,
      setPaymentMethodName,
      paymentMethodName,
    } = useFxFormAddTransactionStore();
    const { paytoAccountsAgreement } = useFormAddTransactionStore();
    const {
      isUpdateTran: isUpdateTxn,
      isDisabled: isPreventRemoveDiscountWhenPaymentMethodChange,
    } = useFxAddTransaction();

    const { onShowAddPaytoAccountModal } = usePayto();

    const { preventPaymentMethodSelection } = usePayment();

    const isSelected = paymentMethodName === method?.method;

    const isPayLimit = isDisabled;

    const {
      discountApplied,
      discountsAvailable,
      discountsInactive,
      discountDetails,
    } = paymentMethodStore || {};
    const discountDefault = getDiscountDefault({
      discountsAvailable,
      discountsInactive,
    });

    // const getDiscountsAvailable = (paymentMethodName) => {
    //   if (paymentMethodName) {
    //     fetchFxDiscountsAvailable({
    //       token,
    //     });
    //   }
    // };
    // useEffect(() => {
    //   if (!isUpdateTxn && isSelected && paymentMethodName && !discountApplied) {
    //     getDiscountsAvailable(paymentMethodName);
    //   }
    // }, [isSelected, paymentMethodName]);

    const { resetPaytoAccountsAgreement } = usePaytoStore();

    const paymentMethodItemClassName = `payment-method-item-${method?.method}`;
    const paymentMethodImageSubDesc = `image-sub-desc-${method?.method}`;
    // useTextScaleFontSize(
    //   paymentMethodImageSubDesc,
    //   paymentMethodItemClassName,
    //   '12px',
    //   '10px'
    // );

    const paymentMethodOnSelectReferences = {
      [METHOD_PAYTO]: () => {
        if (isDisabled) {
          console.log(
            `⭐ PaymentMethodItem 👉 METHOD_PAYTO ➡️ onSelect ➡️ isDisabled ↩`
          );
        } else {
          console.log(`⭐ PaymentMethodItem 👉 METHOD_PAYTO ➡️ onSelect ↩`);
          onSelectPaytoAccountAgreement();
        }
      },
      [METHOD_PAYID]: () => {
        console.log(`⭐ PaymentMethodItem 👉 METHOD_PAYID ➡️ onSelect ↩`);
        resetPaytoAccountsAgreement();
      },
      [METHOD_DEPOSIT]: () => {
        console.log(`⭐ PaymentMethodItem 👉 METHOD_DEPOSIT ➡️ onSelect ↩`);
        resetPaytoAccountsAgreement();
      },
      [METHOD_EPAYMENT]: () => {
        console.log(`⭐ PaymentMethodItem 👉 METHOD_EPAYMENT ➡️ onSelect ↩`);
        resetPaytoAccountsAgreement();
      },
    };
    const handlePaymentMethodSelected = (e, method) => {
      console.log(
        `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ CLICK ↩`
      );
      if (
        e?.target?.tagName === 'IMG' &&
        e?.target?.className?.includes('question-icon')
      ) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ return 1 ↩`
        );
        return;
      }

      if (preventPaymentMethodSelection(e, method)) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ return 2 ↩`
        );
        return;
      }

      const isPaytoBlocked =
        method === METHOD_PAYTO &&
        isArray(paytoAccountsAgreement) &&
        paytoAccountsAgreement?.some(
          (accountAgreement) => accountAgreement?.blocked
        );
      if (isPaytoBlocked) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ return 3 ↩`
        );
        return;
      }

      paymentMethodOnSelectReferences?.[method]?.();

      const newInformation = {
        ...information,
        [FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]: method,
      };

      if (isUpdateTxn && paymentMethodCache && method !== paymentMethodCache) {
        if (method !== paymentMethodName) {
          setOpenFxPaymentMethodOnChangePopup(true);
        }
        setInformationChangeBackup(newInformation);
        return;
      }

      if (isPreventRemoveDiscountWhenPaymentMethodChange) {
        setInformation(newInformation);
        setValidation(initialFormField);
        const newPaymentMethod = {
          ...paymentMethodStore,
          [FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]: method,
        };
        setPaymentMethod(newPaymentMethod);
        return;
      }

      const isCheckDiscountAppliedAfterTxnCreated =
        checkDiscountAppliedValidWhenPaymentMethodChangeAfterTxnCreated({
          isUpdateTxn,
          discount: discountDetails,
          currentPaymentMethodSelected: method,
        });

      const isCheckDiscountAppliedBeforeTxnCreated =
        checkDiscountAppliedInvalidWhenPaymentMethodChangeBeforeTxnCreated({
          isUpdateTxn,
          discountApplied,
          prevPaymentMethodSelected:
            paymentMethodStore[FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME],
          currentPaymentMethodSelected: method,
        }) && !isCheckDiscountAppliedAfterTxnCreated;

      if (
        paymentMethodName &&
        isEmpty(discountDefault) &&
        (isCheckDiscountAppliedBeforeTxnCreated ||
          (discountApplied && !isCheckDiscountAppliedAfterTxnCreated))
      ) {
        setOpenDiscountImportantPopup(true);

        setInformationChangeBackup(newInformation);

        return;
      }

      setInformation(newInformation);

      setValidation(initialFormField);

      const newPaymentMethod = {
        ...paymentMethodStore,
        ...newInformation,
        ...(paymentMethodName &&
          isEmpty(discountDefault) && {
            discountsAvailable: [],
            discountsInactive: [],
          }),
        ...(paymentMethodName &&
          isEmpty(discountDefault) &&
          !isCheckDiscountAppliedAfterTxnCreated && {
            discountApplied: null,
          }),
      };
      setPaymentMethod(newPaymentMethod);
    };

    const handlePaymentMethodDisabledSelected = (e) => {
      console.log(
        `⭐ PaymentMethodItem 👉 handlePaymentMethodDisabledSelected ➡️ CLICK ↩`
      );
      if (
        (e?.target?.tagName === 'IMG' &&
          e?.target?.className?.includes('question-icon')) ||
        e?.target?.className?.includes('payto-disable-details')
      ) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodDisabledSelected ➡️ return ↩`
        );
        return;
      }

      const newInformation = {
        ...information,
        [FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]: '',
      };
      setInformation(newInformation);

      const isPaytoBlocked =
        method?.method === METHOD_PAYTO &&
        isArray(paytoAccountsAgreement) &&
        paytoAccountsAgreement?.some(
          (accountAgreement) => accountAgreement?.blocked
        );
      if (isPaytoBlocked) {
        setPaymentMethodName();
      } else {
        setPaymentMethodName(method?.method);
      }
    };

    const validRef = useRef(null);
    useScrollIntoView(validRef, true, [paymentMethodCache, paymentMethodName]);

    const handleShowPaymentInstructionModal = () => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.FX_PAYMENT_INSTRUCTION_MODAL,
        title: method?.method,
        content: (
          <InstructionBodyContent
            dangerouslySetInnerHTML={{
              __html: t(
                FX_ADD_TRANSACTION_PAYMENT_METHOD_INSTRUCTION[method?.method],
                {
                  amount: format.toAmountCentStr(2000),
                  phone: FX_PHONE,
                  email: FX_EMAIL,
                  host: HOME_URL[theme],
                }
              ),
            }}
          />
        ),
      });
    };

    const renderBodyContentComponent = () => {
      const getBodyContentOnClick = () => {
        if (
          method?.method === METHOD_DEPOSIT ||
          method?.method === METHOD_PAYID ||
          method?.method === METHOD_EPAYMENT
        )
          return;
        if (method?.method === METHOD_PAYTO) {
          setValidation(initialFormField);
          const newPaymentMethod = {
            ...paymentMethodStore,
            [FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]: '',
          };
          setPaymentMethod(newPaymentMethod);
          onShowAddPaytoAccountModal();
          return;
        }
        return;
      };
      const bodyContentComponentReferences = {
        [METHOD_PAYTO]: PaytoBodyContent,
      };
      const renderBodyContentCommon = () => {
        const isPaytoBlocked =
          isArray(paytoAccountsAgreement) &&
          paytoAccountsAgreement?.some(
            (accountAgreement) => accountAgreement?.blocked
          );
        return (
          <>
            {method?.label && (
              <p
                ref={validRef}
                className="image-label"
                dangerouslySetInnerHTML={{
                  __html: stringUtils.replaceBreakLine(t(method?.label)),
                }}
              />
            )}
            {method?.desc && <p className="image-desc">{t(method?.desc)}</p>}
            {method?.method === METHOD_PAYTO &&
              !isPaytoBlocked &&
              method?.payLimitDesc &&
              payLimit?.payLimitMax && (
                <p
                  className={`image-sub-desc ${paymentMethodImageSubDesc}`}
                  style={{
                    whiteSpace: 'nowrap',
                  }}
                >{`${t(
                  method.payLimitDestFeesIncluded
                )} ≤ ${format.toAmountCentStr(payLimit?.payLimitMax)} AUD`}</p>
              )}
          </>
        );
      };
      const BodyContentComponent =
        bodyContentComponentReferences?.[method?.method] || null;

      if (BodyContentComponent)
        return (
          <BodyContentComponent
            onClick={getBodyContentOnClick}
            renderBodyContentCommon={renderBodyContentCommon}
            isPayLimit={isPayLimit}
          />
        );
      if (isPayLimit)
        return (
          <>
            <>{renderBodyContentCommon()}</>
            {method?.payLimitDesc &&
              isDisabled &&
              method?.method === METHOD_EPAYMENT &&
              payLimit?.payLimitMax && (
                <p
                  className={`image-sub-desc ${paymentMethodImageSubDesc}`}
                  style={{
                    whiteSpace: 'nowrap',
                  }}
                >{`${t(
                  method.payLimitDestFeesIncluded
                )} ≤ ${format.toAmountCentStr(payLimit?.payLimitMax)} AUD`}</p>
              )}
          </>
        );
      return (
        <>
          <>{renderBodyContentCommon()}</>
          {method?.payLimitDesc &&
            method?.method === METHOD_EPAYMENT &&
            payLimit?.payLimitMax && (
              <p
                className={`image-sub-desc ${paymentMethodImageSubDesc}`}
                style={{
                  whiteSpace: 'nowrap',
                }}
              >{`${t(
                method.payLimitDestFeesIncluded
              )} ≤ ${format.toAmountCentStr(payLimit?.payLimitMax)} AUD`}</p>
            )}
        </>
      );
    };

    const renderTagIcon = () => ({
      [METHOD_PAYTO]: () => {
        if (!isEmpty(paytoAccountsAgreement)) return null;
        if (isEmpty(method?.tagIcon)) return null;
        return (
          <TagIcon src={method?.tagIcon?.[locate]} width={62} height={30} />
        );
      },
    });

    if (isPayLimit) {
      return (
        <PaymentMethodItemStyled
          $isSelected={isSelected}
          $isDisabled={isDisabled}
          onClick={(e) =>
            handlePaymentMethodDisabledSelected(e, method?.method)
          }
          className={paymentMethodItemClassName}
        >
          <ImageWrap
            $isSelected={isSelected}
            $isDisabled={isDisabled}
            $isPayLimit={isPayLimit}
          >
            <img src={method?.icon} alt={method?.label} />
            {renderBodyContentComponent()}
          </ImageWrap>
          <InstructionImage
            className="question-icon"
            src={QuestionIcon}
            width={20}
            height={20}
            onClick={handleShowPaymentInstructionModal}
            style={{
              marginTop: '-20px',
            }}
          />
        </PaymentMethodItemStyled>
      );
    }
    return (
      <>
        <PaymentMethodItemStyled
          $isSelected={isSelected}
          $isDisabled={isDisabled}
          $isRequired={!isDisabled && isSelectRequired}
          onClick={(e) => handlePaymentMethodSelected(e, method?.method)}
          className={paymentMethodItemClassName}
        >
          <ImageWrap $isSelected={isSelected} $isPayLimit={false}>
            <img
              src={isSelected ? method?.iconColor : method?.icon}
              alt={method?.label}
            />
            {renderBodyContentComponent()}
          </ImageWrap>
          {renderTagIcon()?.[method?.method]?.()}
          <InstructionImage
            className="question-icon"
            src={QuestionIcon}
            width={20}
            height={20}
            onClick={handleShowPaymentInstructionModal}
            style={{
              zIndex: isEmpty(paytoAccountsAgreement) && 1,
            }}
          />
        </PaymentMethodItemStyled>
      </>
    );
  }
);

const PaymentMethodItemStyled = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  box-shadow: 0px 4px 15px 0px #0000001a;
  cursor: pointer;
  padding: 10px;
  position: relative;
  background-color: ${(props) => (props.$isSelected ? '#FEF0D1' : 'unset')};
  border: ${(props) =>
    props.$isRequired ? '1px solid var(--ds-c-red)' : '1px solid transparent'};
  ${(props) =>
    props.$isDisabled &&
    `
    background-color: #eeeeee;
    border: 1px solid transparent;
  `};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 206px;
    height: 162px;
  }
`;

const ImageWrap = styled.div`
  font-family: var(--ff-primary);
  font-style: normal;
  color: var(--ds-c-grey-dark);
  user-select: none;

  display: grid;
  align-items: center;
  justify-items: center;
  margin-top: 0px;
  width: 100%;

  & img {
    width: 62px;
    height: 50px;
    object-fit: contain;
    margin-bottom: 4px;
    ${(props) => props.$isDisabled && 'filter: grayscale(1)'};
  }

  & p.image-label {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    text-align: center;
    white-space: break-spaces;

    width: 100%;
    margin-bottom: 4px;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
      width: 162px;
    }
  }

  & p.image-desc {
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
    text-transform: capitalize;

    margin-bottom: 0px;
  }

  & p.image-sub-desc {
    font-size: 10px;
    line-height: 15px;
    font-weight: 500;
    text-transform: capitalize;
    color: ${(props) =>
      props.$isPayLimit ? 'var(--ds-c-red)' : 'var(--ds-c-blue)'};

    margin-bottom: 0px;
    margin-top: 2px;
  }
`;

const InstructionImage = styled.img`
  align-self: end;
  padding: 10px;
  margin-right: -10px;
  margin-bottom: -10px;
  margin-top: -10px;
  width: 40px !important;
  height: 40px !important;
`;
const InstructionBodyContent = styled.div`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--ds-c-grey-dark);
  ${textBreakLineWordMixin};

  width: 100%;
  padding-bottom: 8px;

  & p {
    cursor: text;
    margin: 0;
    padding: 0;
  }

  & p.instruction-title {
    font-weight: 600;
    text-transform: uppercase;
    color: var(--ds-c-green-default);
    margin-bottom: 20px;
  }

  & p.instruction-content {
  }

  & p.instruction-contact {
  }

  & a {
    color: var(--ds-c-blue-hyperlink-default) !important;
    text-decoration: none;
    text-transform: none;

    &:focus,
    &:focus-visible,
    &:active {
      color: var(--ds-c-blue-hyperlink-default) !important;
    }

    &:hover {
      color: var(--ds-c-blue-hyperlink-hover) !important;
    }
  }

  & span {
    font-weight: 700;
  }

  & span.warning {
    font-weight: 500;
    color: var(--ds-c-red);
  }

  & ol {
    margin: 0;
    padding-left: 24px;

    & li {
      list-style: auto;
      list-style-type: decimal;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const TagIcon = styled.img`
  width: 50px;
  height: 24px;
  object-fit: cover;
  position: absolute;
  top: -1px;
  right: -1px;
  border-radius: 0 8px;
`;

export default PaymentMethodItem;
